import React from "react"
import PropTypes from "prop-types"
import TextField from "material-ui/TextField"
let saveTimeout

const propTypes = {
    handleChange: PropTypes.func,
    style: PropTypes.object
}

export default class SocialSecurityNumberField extends React.Component {
    constructor(props) {
        super()
        this.state = {
            ssn: "",
            rawNumber: "",
            blurred: false,
            hasChanged: false
        }

        this.handleChange = this.handleChange.bind(this)
        this.onFocus = this.onFocus.bind(this)
        this.onBlur = this.onBlur.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                ssn: this.getValue(nextProps.value).ssn,
                rawNumber: nextProps.value
            })
        }
    }

    handleChange(event) {
        const ssnObject = this.getValue(event.target.value, true)

        //Only change if really changed.
        if (this.state.rawNumber !== ssnObject.rawNumber) {
            this.setState(
                {
                    ssn: ssnObject.ssn,
                    rawNumber: ssnObject.rawNumber,
                    hasChanged: true
                },
                () => {
                    const valid = this.validate()

                    //Don't send over every change right away, do it on a timer so that it can be saved server-side by parent
                    if (saveTimeout) {
                        clearTimeout(saveTimeout)
                    }
                    saveTimeout = setTimeout(() => {
                        if (this.props.handleChange) {
                            this.props.handleChange(this.state.rawNumber, valid)
                        }
                    }, 750)
                }
            )
        }
    }

    getValue(rawValue, changed) {
        if (this.isObfuscatedValue(rawValue)) {
            //If we are making a change for the first time, then just empty it out.
            if (!this.state.hasChanged && changed) {
                return { rawNumber: "", ssn: "" }
            }

            return { rawNumber: rawValue, ssn: rawValue }
        }

        let rawNumber = rawValue.replace(/\D/g, "")
        if (rawNumber.length > 9) {
            rawNumber = rawNumber.substring(0, 9)
        }

        const ssn = this.markupSSN(rawNumber, rawNumber)
        return { rawNumber: rawNumber, ssn: ssn }
    }

    isObfuscatedValue(rawValue) {
        return rawValue.startsWith("***-**")
    }

    markupSSN(rawValue, rawNumber) {
        const enDash = "–"
        if (rawValue.endsWith(enDash)) {
            rawValue = rawValue.substring(0, rawValue.length - 1)
        }

        let ssnValue = rawNumber
        if (rawNumber.length > 9) {
            rawNumber = rawNumber.substring(0, 9)
        }

        if (rawNumber.length > 3) {
            if (rawNumber.length > 5) {
                ssnValue = rawNumber.substring(0, 3) + enDash + rawNumber.substring(3, 5) + enDash + rawNumber.substring(5)
            } else {
                ssnValue = rawNumber.substring(0, 3) + enDash + rawNumber.substring(3)
            }
        }

        return ssnValue
    }

    validate() {
        const valid = this.state.rawNumber.length === 9
        if (!valid) {
            if (this.state.blurred && this.state.hasChanged) {
                this.setState({
                    errorText: "Invalid SSN"
                })
            }
        } else {
            this.setState({
                errorText: ""
            })
        }

        return valid
    }

    onBlur() {
        this.setState(
            {
                blurred: true
            },
            () => {
                this.validate()
            }
        )
    }

    onFocus() {
        this.refs.field.input.select()
    }

    render() {
        return (
            <div className="SocialSecurityNumberField" style={this.props.style}>
                <TextField
                    floatingLabelText="U.S. Social Security Number"
                    value={this.state.ssn}
                    onChange={this.handleChange}
                    style={{ width: "100%" }}
                    errorText={this.state.errorText}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    ref="field"
                />
            </div>
        )
    }
}

SocialSecurityNumberField.propTypes = propTypes
